import type { ContentMount } from '../contentMount';

export interface EditSection {
  label: string;
  // The section's route under the edit page, once it has moved into the SPA; unset while it is
  // still on the legacy form.
  path?: string;
}

// The legacy edit form's sections (admin/programs/_form), in its order.
export const editSections: EditSection[] = [
  { label: 'Program Information', path: '' },
  { label: 'Program Settings', path: 'settings' },
  { label: 'Correlations', path: 'correlations' },
  { label: 'Store Order URLs', path: 'store-urls' },
  { label: 'Program Images', path: 'images' },
  { label: 'Question Bank Filters', path: 'question-bank' },
  { label: 'Program Resources', path: 'resources' },
];

// The New Program page's router path on each mount; on the legacy mount it is the Rails new URL.
export const programNewPath = (mount: ContentMount) => (mount === 'legacy' ? '/new' : '/content/programs/new');

// The edit page's router path on each mount. The legacy mount is based at /admin/programs and
// routes /:programId/edit, so its links are the Rails edit URL and a reload lands on the same page.
export const programEditPath = (programId: number, mount: ContentMount, section = '') => {
  const base = mount === 'legacy' ? `/${programId}/edit` : `/content/programs/${programId}/edit`;

  return section ? `${base}/${section}` : base;
};
